import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router/dom";
import { createRoot } from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";

import "./assets/css/app.css";

import App from "./App";
import store from "./system/store";
import reportWebVitals from "./reportWebVitals";
import { SignalRProvider } from "./system/signalRContext";
import { createAppRouter } from "./system/appRouter";
import ErrorBoundary from "./shared/components/errorBoundary/errorBoundary";
import { Spinner } from "./shared";
import { initializeSentry } from "./config/sentry";

initializeSentry();
const container = document.getElementById("root");
const root = createRoot(container);

const router = createAppRouter(<App />);
root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <Suspense fallback={<Spinner />}>
        <SignalRProvider>
          <RouterProvider router={router} />
        </SignalRProvider>
      </Suspense>
    </ErrorBoundary>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
